import { CandidateQuestionDto } from "./candidate-question-dto";
import { QuestionAnswerStateDTO } from "./state/question-answer-state-dto";

export class SaveQuestionAnswersDTO {
	public questionAnswers!: QuestionAnswerStateDTO[];
	public candidateQuestion!: CandidateQuestionDto;
	public currentQuestionNumber!: number;
}
